{
  "BULK_ACTION": {
    "CONVERSATIONS_SELECTED": "{conversationCount} samtaler valgt",
    "AGENT_SELECT_LABEL": "Vælg agent",
    "ASSIGN_CONFIRMATION_LABEL": "Are you sure to assign {conversationCount} {conversationLabel} to",
    "UNASSIGN_CONFIRMATION_LABEL": "Are you sure to unassign {conversationCount} {conversationLabel}?",
    "GO_BACK_LABEL": "Gå tilbage",
    "ASSIGN_LABEL": "Tildel",
    "YES": "Ja",
    "SEARCH_INPUT_PLACEHOLDER": "Søg",
    "ASSIGN_AGENT_TOOLTIP": "Tildel agent",
    "ASSIGN_TEAM_TOOLTIP": "Tildel team",
    "ASSIGN_SUCCESFUL": "Samtaler tildelt.",
    "ASSIGN_FAILED": "Failed to assign conversations. Please try again.",
    "RESOLVE_SUCCESFUL": "Samtaler løst med succes.",
    "RESOLVE_FAILED": "Failed to resolve conversations. Please try again.",
    "ALL_CONVERSATIONS_SELECTED_ALERT": "Samtaler synlig på denne side er kun valgt.",
    "AGENT_LIST_LOADING": "Indlæser agenter",
    "UPDATE": {
      "CHANGE_STATUS": "Skift status",
      "SNOOZE_UNTIL": "Udsæt",
      "UPDATE_SUCCESFUL": "Samtalens status blev opdateret.",
      "UPDATE_FAILED": "Failed to update conversations. Please try again."
    },
    "LABELS": {
      "ASSIGN_LABELS": "Assign labels",
      "NO_LABELS_FOUND": "Ingen etiketter fundet for",
      "ASSIGN_SELECTED_LABELS": "Tildel valgte etiketter",
      "ASSIGN_SUCCESFUL": "Etiketter tildelt med succes.",
      "ASSIGN_FAILED": "Failed to assign labels. Please try again."
    },
    "TEAMS": {
      "TEAM_SELECT_LABEL": "Vælg hold",
      "NONE": "Ingen",
      "NO_TEAMS_AVAILABLE": "There are no teams added to this account yet.",
      "ASSIGN_SELECTED_TEAMS": "Tildel det valgte team.",
      "ASSIGN_SUCCESFUL": "Teams assigned successfully.",
      "ASSIGN_FAILED": "Failed to assign team. Please try again."
    },
    "MERGE": {
      "TOOLTIP": "Sammenflet samtaler",
      "TITLE": "Sammenflet samtaler",
      "DESCRIPTION": "Vælg en målsamtale. Alle andre valgte samtaler bliver sammenflettet med den — deres beskeder bliver flyttet til målsamtalen, og kildesamtalerne bliver slettet.",
      "TARGET_LABEL": "Målsamtale (bevares)",
      "SOURCES_LABEL": "Kildesamtaler (slettes)",
      "SELECT_TARGET": "Vælg en samtale som mål for sammenfletningen",
      "WARNING": "Advarsel: Denne handling kan ikke fortrydes. Beskeder fra alle kildesamtaler bliver flyttet til målsamtalen, og kildesamtalerne bliver slettet permanent.",
      "SUBMIT": "Sammenflet samtaler",
      "CANCEL": "Annuller",
      "SUCCESS_MESSAGE": "Samtalerne blev sammenflettet",
      "ERROR_MESSAGE": "Kunne ikke sammenflette samtalerne. Prøv venligst igen.",
      "CONFIRM": {
        "TITLE": "Bekræft sammenfletning",
        "DESCRIPTION": "Er du sikker på, at du vil sammenflette {sourceCount} samtaler til #{targetId}? Denne handling kan ikke fortrydes.",
        "YES": "Ja, sammenflet",
        "CANCEL": "Annuller"
      }
    }
  }
}
